var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("当前位置:\n  "),_c('span',[_vm._v("首页")]),_vm._v("\n  >\n  "),_c('span',{staticClass:"currentTab"},[_vm._t("sonPath")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }